export default __webpack_public_path__ + "static/media/Devils.8dc08fd8.png";